module.exports = __webpack_public_path__ + "static/media/ian-signature.9611ced6.png";